module.exports = __webpack_public_path__ + "static/media/midrive_icon.7c996715.png";